import React from 'react'
import illustration from '../../../../shared/assets/empty-illustration.svg'
import { StubContactLinks } from '../../../../lib/widgets/stubs/StubContactLinks'

export const TabAcceptedStub = () => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>No data</h2>
            <p className={'text-center text-[15px] text-[#8E7CA7]'}>Why am I seeing this?</p>
          </div>
          <div
            className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
          >
            <p className={'text-center text-focus-500'}>
              Once the complaint has been accepted Google will apply restrictions and remove the ads
              shortly
            </p>
          </div>
          <div className={'flex justify-center'}>
            <p className={'max-w-[254px] text-center text-[13px] leading-[18px] text-[#8E7CA7]'}>
              💡 Go to “Removed” to confirm removal
            </p>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
